<template>
  <ViewCover v-if="$store.getters.user.mode == 'ADMINISTRATOR'" :style="`padding:  8px 8px 8px ${sidebar_width + 8}px !important;`">
    <!-- <PhoneField v-model="d"/> -->
    <ContextNavigator 
      absolute
      :title="$t('Параметры')"
      back_ref="/"
      :items="nav_items"
      style="min-height: 100%"
      :width="sidebar_width"
    />


    <!-- <div style="background: red; width: 100%; height: 100%; flex-grow: 1 ">asd</div> -->

    <SettingsGroupView>
      <template #title>
        <span id="settings-group-header"></span>
      </template>

      <transition name="fade" mode="out-in">
        <!-- <router-view v-if="appear" keep-alive /> -->
        <!-- <component v-if="appear" :is="component" /> -->
        <component :is="component" />
      </transition>

      <template #actions >
        <v-spacer></v-spacer>
        <div id="settings-group-actions"></div>
      </template>      
    </SettingsGroupView>
  </ViewCover>
  <Forbidden v-else/>
</template>

<script>
import Forbidden from '../components/common/Forbidden.vue'
import SettingsGroupView from './SettingsGroupView.vue'
import ViewCover from './ViewCover.vue'
import ContextNavigator from '../components/common/ContextNavigator'
// import PhoneField from '../components/common/PhoneField.vue'

export default {
  data: () => ({
    appear: false,
    d: ''
  }),
  mounted(){
    this.$nextTick(() => this.appear = true)
  },
  components: {
    // PhoneField,
    ViewCover,
    ContextNavigator,
    SettingsGroupView,
    Forbidden
  },
  methods: {
    kebabToCamel(str) {
      let words = str.split('-')
      return words.reduce((prev, el) => `${prev}${el.charAt(0).toUpperCase()+el.slice(1)}`, '')
    }
  },
  computed: {
    component_name(){
      return this.kebabToCamel(this.$route.params.setting_page)
    },
    component(){
      if (this.component_name) {
        return async () => {
          try {
            return await import(`@/views/settings/${this.component_name}`)
          } catch {
            return await import(`@/views/settings/NotFound`)
          }
        }
      } else {
        return ''
      }
    },
    sidebar_width(){
      return 280
    },
    nav_items(){
      let items = []
      items.push({
        text: this.$t('Подключение к r_keeper'),
        icon: 'mdi-connection',
        link: 'r-keeper',
        badge: false
      })
      items.push({
        text: this.$t('Авторизация'),
        icon: 'mdi-account-multiple',
        link: 'authorization',
        badge: false
      })
      items.push({
        text: this.$t('Справочники'),
        icon: 'mdi-view-list',
        link: 'references',
        badge: false
      })
      items.push({
        text: this.$t('Меню ресторана'),
        icon: 'mdi-silverware',
        link: 'menu',
        badge: false
      })
      items.push({
        text: this.$t('График работы'),
        icon: 'mdi-clock',
        link: 'schedule',
        badge: false
      })

      items.push({
        text: this.$t('Настройка доставки'),
        icon: 'mdi-airplane-cog',
        link: 'rules',
        badge: false
      })

      items.push({
        text: this.$t('Онлайн оплата'),
        icon: 'mdi-cash-multiple',
        link: 'pay-settings',
        badge: false
      })

      items.push({
        text: this.$t('Геокодирование'),
        icon: 'mdi-map-search',
        link: 'geocoding',
        badge: false
      })
      // if (this.$store.getters.local_refs.geocoding.enabled === true) {
      //   items.push({
      //     text: this.$t('Зоны доставки'),
      //     icon: 'mdi-map-marker-radius',
      //     link: 'dlvzone',
      //     badge: false
      //   })
      // }

      items.push({
        text: this.$t('API доставки'),
        icon: 'mdi-code-braces-box',
        link: 'integrations',
        badge: false
      })

      items.push({
        text: this.$t('Уведомления'),
        icon: 'mdi-message-text',
        link: 'notifications',
        badge: false
      })
      // items.push({
      //   text: this.$t('Курьерская служба'),
      //   icon: 'mdi-run-fast',
      //   link: 'couriers',
      //   badge: false
      // })
      items.push({
        text: this.$t('Локальный сервер'),
        icon: 'mdi-server',
        link: 'server',
        badge: false
      })
      // items.push({
      //   text: this.$t('Логирование'),
      //   icon: 'mdi-notebook',
      //   link: 'logging',
      //   badge: false
      // })

      return items
    }
  }
}
</script>